module.exports = __webpack_public_path__ + "img/SKMJ_etc2.c4cb064d.jpg";